jQuery(window).on("scroll", function(){
    jQuery(".scroll-indicator").fadeOut(1000);
});
